<!--成本应付账户-->
<template>
  <div class="app-container">
    <el-card class="mb5 searchContainer">
      <el-form
        ref="queryForm"
        class="queryFormClass"
        :model="queryForm"
        label-position="top"
        size="small"
      >
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item :label="$t('basicData.accountsPayableToSuppliers')">
              <el-input v-model.trim="queryForm.params.providerName" :placeholder="$t('GlobalSetObj.pleaseInputContent')" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--名称-->
            <el-form-item :label="$t('orderCenterCont.name')">
              <el-input v-model.trim="queryForm.params.providerBody" :placeholder="$t('GlobalSetObj.pleaseInputContent')" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row type="flex" justify="left">
        <el-col :span="8">
          <div>
            <!--查询-->
            <el-button
              type="primary"
              icon="el-icon-search"
              size="mini"
              @click="getDataSearch(1)"
            >{{ $t('basicData.Search') }}
            </el-button>
            <!--重置-->
            <el-button
              icon="el-icon-refresh"
              size="mini"
              @click="getDataSearch(2)"
            >{{ $t('basicData.reset') }}
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card>
      <div style="margin-bottom: 10px;text-align: right;">
        <!--导出账户信息-->
        <el-button
          v-permit:remove="'but:finance:basicData:CostsPayableAccount:AccountExport'"
          type="primary"
          size="mini"
          icon="el-icon-download"
          @click="exportAccountInformation(1)"
        >{{ $t('basicData.ExportAccountInformation') }}
        </el-button>
        <!--导出账户流水-->
        <el-button
          v-permit:remove="'but:finance:basicData:CostsPayableAccount:FlowOutExport'"
          type="primary"
          size="mini"
          icon="el-icon-download"
          @click="exportAccountInformation(2)"
        >{{ $t('basicData.ExportAccountRollover') }}
        </el-button>
      </div>
      <el-table
        :data="tableData"
        border
        class="table-height"
        :height="tableHeightRow.height"
      >
        <!--序号-->
        <el-table-column
          :label="$t('basicData.serialNumber')" type="index" width="60"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <!--业务类型-->
        <el-table-column
          v-for="(item, ind) in accountSection"
          :key="ind"
          :prop="item.prop"
          :label="item.label"
          :align="item.align"
          :min-width="item.width"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div v-if="item.prop === 'providerName'">
              <el-popover
                placement="top-end"
                popper-class="copy"
                trigger="hover"
              >
                <!--复制-->
                <el-button type="text" @click="copy(scope.row.providerName)">{{ $t('orderDetails.copy') }}</el-button>
                <span slot="reference" style="color: #00A551;cursor: pointer;" @click="handlerOperation(scope.row)">{{ scope.row.providerName }}</span>
              </el-popover>
            </div>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryForm.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="queryForm.pageSize"
          :total="total"
          background
          style="margin: 10px 0"
          @current-change="getCurrentData"
          @size-change="getSizeData"
        />
      </div>
    </el-card>
    <!--账户详情-->
    <el-drawer
      :append-to-body="true"
      :title="$t('basicData.AccountDetails')"
      :visible.sync="showAccountDetails"
      custom-class="drawerClass"
      direction="ltr"
      size="70%"
    >
      <check-detail
        :key="detailKey"
        :detail-data="detailData"
        :type="5"
        @clearDetail="clearDetail"
      />
    </el-drawer>
  </div>
</template>

<script>
import { getUserName } from '@/utils/asyncTools';
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import { copyData } from '@/utils/copyData';
import { apiCostPayableAccountExport, apiCostPayableAccountPage, apiSiteCostExportOfBillFlow } from '@/api/finance/basicData';
import { cloneDeep } from 'lodash-es';
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight.js';
import { goFinanceExportPage } from '@/utils/goExportList.js';

export default {
  name: 'CostsPayableAccount',

  components: {
    'check-detail': () => import('@/views/finance/basicData/cope/accountsPayable/cmp/checkDetail.vue')
  },
  mixins: [estimateTableHeight],
  data() {
    return {
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          providerName: '',
          providerBody: ''
        }
      },
      tableData: [],
      total: 0,
      accountSection: [
        // 供应商账户
        { label: this.$t('basicData.accountsPayableToSuppliers'), prop: 'providerName', width: 160, align: 'left' },
        // 名称
        { label: this.$t('orderCenterCont.name'), prop: 'providerBody', width: 160, align: 'left' },
        // 付款总计
        { label: this.$t('basicData.totalPaymentAmount'), prop: 'totalPaymentAmount', width: 160, align: 'left' },
        // 已付总计
        { label: this.$t('basicData.totalPaid'), prop: 'paidAmount', width: 160, align: 'left' },
        // 未付总计
        { label: this.$t('basicData.unpaidTotal'), prop: 'unpaidAmount', width: 160, align: 'left' }
      ],
      showAccountDetails: false,
      detailData: null,
      detailKey: new Date().getTime()
    };
  },

  created() {
    this.userIdAndNameObj = getUserIdAndNameObj();
    this.getTableData();
  },
  methods: {
    // 关闭弹窗详情
    clearDetail() {
      this.showAccountDetails = false;
    },
    // 点击复制
    copy(data) {
      copyData(data);
    },
    // 应付账户列表查询
    getTableData() {
      apiCostPayableAccountPage(this.queryForm).then(res => {
        if (res.code === 200) {
          const { records, total } = res.data;
          this.tableData = (records || []).map(item => {
            const updateUserStr = getUserName(item.updateUser, this.userIdAndNameObj);
            const createUserStr = getUserName(item.createUser, this.userIdAndNameObj);
            return Object.freeze({
              ...item,
              updateUserStr,
              createUserStr
            });
          });
          this.total = total;
        }
      });
    },
    // 导出账户信息、 导出账户流水
    exportAccountInformation(type) {
      if (type === 1) {
        apiCostPayableAccountExport(this.queryForm.params).then(res => {
          if (res.code === 200) {
            goFinanceExportPage();
          }
        });
      } else {
        const param = cloneDeep(this.queryForm);
        param.params.isSiteDetailsRequest = false;
        apiSiteCostExportOfBillFlow(param.params).then(res => {
          if (res.code === 200) {
            goFinanceExportPage();
          }
        });
      }
    },
    // 查询、重置
    getDataSearch(type) {
      this.queryForm.pageNumber = 1;
      if (type === 1) {
        this.getTableData();
      } else {
        this.queryForm.pageSize = 10;
        this.queryForm.params.providerName = '';
        this.queryForm.params.providerBody = null;
      }
    },
    // 页码切换查询
    getCurrentData(val) {
      this.queryForm.pageNumber = val;
      this.getTableData();
    },
    // 每页显示数量切换
    getSizeData(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getTableData();
    },
    // 查看详情
    handlerOperation(row) {
      this.detailData = {
        ...row,
        costPayableAccountCondition: {
          id: row.id
        },
        payableUnsettledAmount: row.totalPaymentAmount, // 应付合计
        payedAmount: row.paidAmount, // 已付合计
        unpavedAmount: row.unpaidAmount // 未付合计
      };
      this.showAccountDetails = true;
      this.detailKey = new Date().getTime();
    }
  }
};
</script>

<style scoped>
.app-container >>> .drawerClass header {
  border-bottom: 1px solid #ccc !important;
  margin-bottom: 0 !important;
  padding: 20px 20px 20px !important;
}
</style>
